import { render, staticRenderFns } from "./Grid122.vue?vue&type=template&id=06023dd4"
import script from "./Grid122.vue?vue&type=script&lang=js"
export * from "./Grid122.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports